import Keycloak, { type KeycloakConfig } from 'keycloak-js';

export const createAuthManager = (config: KeycloakConfig) => {
  const keycloakInstance = new Keycloak(config);

  return {
    get token() {
      return keycloakInstance.token ?? null;
    },

    get idTokenParsed() {
      return keycloakInstance.idTokenParsed ?? null;
    },
    login: async (onAuthenticatedCallback: () => void) => {
      const authenticated = await keycloakInstance.init({
        onLoad: 'login-required',
        checkLoginIframe: false,
      });
      if (authenticated) {
        onAuthenticatedCallback();
      } else {
        alert('non authenticated');
      }
    },
    logout: async () => {
      await keycloakInstance.logout();
    },
    updateToken: async (minValidity?: number) => {
      return await keycloakInstance.updateToken(minValidity ?? 5);
    },
    forceUpdateToken: async () => {
      return await keycloakInstance.updateToken(-1);
    },
  };
};
